/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_StyleInputs */



/**
* | output |
* | --- |
* | "Update Style" |
*
* @param {Update_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_style = /** @type {((inputs?: Update_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour le style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stil aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar estilo")
	return /** @type {LocalizedString} */ ("Update Style")
});